import { AsyncKbNav } from '@atlassian/jira-horizontal-nav-jsm-knowledge-base/src/index.tsx';
import { useHorizontalNavComponent } from '@atlassian/jira-navigation-apps-horizontal-nav-selector/src/controllers/nav-component-controller/index.tsx';
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils/src/index.tsx';

export const useIsKBRouteWithHorizontalNav = () => {
	const route = useCurrentRoute();
	const HorizontalNavComponent = useHorizontalNavComponent();

	return (
		getWillShowNav4() && route.group === 'servicedesk' && HorizontalNavComponent === AsyncKbNav
	);
};
